export class Relationship {
    RelateType;
    CDesc;
    EDesc;
    constructor() {
      this.RelateType = "";
      this.CDesc = "";
      this.EDesc = "";
    }
  }
  


// WEBPACK FOOTER //
// ./src/model/Relationship.js